/* Enjouet — catégories en accordéon (+ / −) sur les pages collection.
   Dans le menu "Catégories", un lien dont le titre commence par "-" (ex. "- Jouets -")
   devient une catégorie ; les liens qui le suivent deviennent ses sous-catégories. */
(function () {
  var uid = 0;

  function headerName(text) {
    var t = (text || '').trim();
    if (t.charAt(0) !== '-') return null;
    t = t.slice(1).trim();
    if (t.slice(-1) === '-') t = t.slice(0, -1).trim();
    return t;
  }

  function setOpen(li, open) {
    li.classList.toggle('is-open', open);
    var b = li.querySelector(':scope > .enj2-tog');
    if (b) b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function build(ul) {
    if (ul.getAttribute('data-enj2-acc')) return;
    var items = Array.prototype.filter.call(ul.children, function (n) { return n.tagName === 'LI'; });
    var hasHeader = items.some(function (li) {
      var l = li.querySelector('.custom-control-label');
      return l && headerName(l.textContent) !== null;
    });
    if (!hasHeader) return;
    ul.setAttribute('data-enj2-acc', '1');
    ul.classList.add('enj2-acc');

    var cur = null, sub = null;
    items.forEach(function (li) {
      var lab = li.querySelector('.custom-control-label');
      var name = lab ? headerName(lab.textContent) : null;
      if (name !== null) {
        lab.textContent = name;
        li.classList.add('enj2-grp');
        sub = document.createElement('ul');
        sub.className = 'enj2-sub list-unstyled';
        sub.id = 'enj2-sub-' + (++uid);
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'enj2-tog';
        b.setAttribute('aria-expanded', 'false');
        b.setAttribute('aria-controls', sub.id);
        b.setAttribute('aria-label', 'Sous-catégories : ' + name);
        var a = li.querySelector(':scope > a');
        if (a && a.nextSibling) li.insertBefore(b, a.nextSibling); else li.appendChild(b);
        li.appendChild(sub);
        cur = li;
        if (li.classList.contains('current-cat')) setOpen(li, true);
      } else if (cur) {
        sub.appendChild(li);
        if (li.classList.contains('current-cat')) setOpen(cur, true);
      }
    });

    // Catégorie sans sous-catégorie : pas de bouton
    Array.prototype.forEach.call(ul.querySelectorAll('.enj2-grp'), function (g) {
      var s = g.querySelector(':scope > .enj2-sub');
      if (s && !s.children.length) {
        s.remove();
        var b = g.querySelector(':scope > .enj2-tog');
        if (b) b.remove();
        g.classList.add('enj2-grp--solo');
      }
    });
  }

  function scan() {
    Array.prototype.forEach.call(document.querySelectorAll('ul.product-categories'), build);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.enj2-tog');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var li = b.parentElement;
    setOpen(li, !li.classList.contains('is-open'));
  }, true);

  var t = null;
  function later() { clearTimeout(t); t = setTimeout(scan, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  if (window.MutationObserver) new MutationObserver(later).observe(document.documentElement, { childList: true, subtree: true });
})();
